import * as React from "react";
import { outlookEvent } from "../../Entity/OutlookEvent";
import EventDetail from "./EventDetails";
import EventAttendeelist from "./eventattendeelist";
import EventAttachmentlist from './Attachmentlist';
import "./event.scss";
//import * as moment from 'moment';
import {
  Facepile,
  IFacepileProps,
  OverflowButtonType
} from "office-ui-fabric-react/lib/Facepile";
import moment from "moment";
import { DateHelper } from "../../Helpers/DateHelper";

export interface IProps {
  data: outlookEvent;
  phrases: any;
  CreateOrCancelPreperationEvent;
  UpdateEvent;
  AcceptEvent;
  Getcrmdataforrecent;
  PrepareContactCRMReportUI;
  PrepareContactCRMSSOUI;
  GetCRMContactCompany;
  GetContactRelatedMails;
  GetOutlookemailAttachments;
  extpropid;
  currentuseremail;
}
export default class Event extends React.Component<IProps> {
  public attendeeattending=[];
  public attendeetentative=[];
  public attendeedeclaine=[];
  public attendeenotresponse=[];
  public facepileProps: IFacepileProps = {
    personas: [],
    maxDisplayablePersonas: 5,
    overflowButtonType: OverflowButtonType.none,
    overflowButtonProps: {
      ariaLabel: "More users",
      onClick: (ev: React.MouseEvent<HTMLButtonElement>) =>
        alert("overflow icon clicked")
    },
    ariaDescription: "To move through the items use left and right arrow keys."
  };

  constructor(props) {
    super(props);
    this.PrepareAttendeesummary();
  }
  public PrepareAttendeesummary=()=>{
    if (this.props.data.attendees && this.props.data.attendees.length > 0) {
      let orguser=this.props.data.attendees.filter(ou=>{return this.props.data.organizer.emailAddress.address==ou.emailAddress.address;});
      if(orguser!=null && orguser.length>0){
        orguser[0].status.response='accepted';
      } else{
        orguser={
          "type": "required",
          "status": {
              "response": "accepted",
              "time": "0001-01-01T00:00:00Z"
          },
          "emailAddress":this.props.data.organizer.emailAddress
        };
        this.props.data.attendees.push(orguser);
      }
      this.props.data.attendees.forEach(cattendee => {
          let resstatus=cattendee.status.response.toLowerCase();
          if(this.props.data.responseStatus.response == "accepted" && cattendee.emailAddress.address==this.props.currentuseremail){
            resstatus="accepted";
          }
          switch (resstatus) {
            case 'none':
            case 'notresponded':
                this.attendeenotresponse.push(cattendee);
                break;
            case 'tentativelyaccepted':
                this.attendeetentative.push(cattendee);
                break;
            case 'accepted':
                this.attendeeattending.push(cattendee);
                break;
            case 'declined':
                this.attendeedeclaine.push(cattendee);
                break;
            default:
              break;
          }
            /*
             {
                    "type": "required",
                    "status": {
                        "response": "none",
                        "time": "0001-01-01T00:00:00Z"
                    },
                    "emailAddress": {
                        "name": "Samaresh Das",
                        "address": "samaresh.das@ixorasolution.com"
                    }
                }
             */
             //None, Organizer, TentativelyAccepted, Accepted, Declined, NotResponded

            
      });
    }
  }
  public getorganizer=()=>{
    let facepileOrganizer: IFacepileProps = {
      personas: [],
      maxDisplayablePersonas: 5,
      overflowButtonType: OverflowButtonType.none,
      overflowButtonProps: {
        ariaLabel: "More users",
        onClick: (ev: React.MouseEvent<HTMLButtonElement>) =>
          alert("overflow icon clicked")
      },
      ariaDescription: "To move through the items use left and right arrow keys."
    };
    let attendee = this.props.data.organizer;
    let name =
        attendee["emailAddress"].name == ""
          ? attendee["emailAddress"].address
          : attendee["emailAddress"].name;
    let parts = name.split(" ");
    name +=' ('+attendee["emailAddress"].address+')';
    let AssingeeInitial = parts[0]
        .trim()
        .substr(0, 1)
        .toUpperCase();
    if (parts.length > 1) {
        AssingeeInitial += parts[1]
          .trim()
          .substr(0, 1)
          .toUpperCase();
      }
    let persion = {
        imageInitials: AssingeeInitial,
        personaName: name,
        initialsColor: Math.floor(Math.random() * 15)
      };
    facepileOrganizer.personas.push(persion);
    return facepileOrganizer;
  }
  public render() {
    //prepid
    this.facepileProps.personas = [];
    let fifteenmincss="outlookeventbookbutton ";
    let thirtymincss="outlookeventbookbutton ";
    let fifteenmincaption=this.props.phrases.book15minbefor;
    let fifteenminovercaption=this.props.phrases.bookbutton;
    let thirtymincaption=this.props.phrases.book30minbefor;
    let thirtyminovercaption=this.props.phrases.bookbutton;

    if(this.props.data.booktime!=0){
      if(this.props.data.booktime==-15){
        fifteenmincss +="outlookeventbookbuttonactive";
        thirtymincss +="outlookeventbookbuttondisable";

        fifteenmincaption=this.props.phrases.book15minbooked;
        fifteenminovercaption=this.props.phrases.cancel;
      }else if(this.props.data.booktime==-30){
        thirtymincss +="outlookeventbookbuttonactive";
        fifteenmincss +="outlookeventbookbuttondisable";

        thirtymincaption=this.props.phrases.book30minbooked;
        thirtyminovercaption=this.props.phrases.cancel;
      }
    }
    //let assignecount=0;
    
 // https://outlook.office.com/calendar/deeplink/read/{id}
 //https://outlook.office.com/mail/deeplink?viewmodel=IAttachmentViewModelPopoutFactory&AttachmentId={}&ItemId={}&AttachmentName={}
    let start = new Date(this.props.data.start.dateTime);
    let end = new Date(this.props.data.end.dateTime);
    let meetingduration='';
    let duration = DateHelper.GetDateDiffInminutes (end, start);
    meetingduration = duration+'m';
    if (duration >= 60) {
      meetingduration = (Math.floor(duration / 60)).toString() + 'h';
      if (duration % 60 > 0) {
        meetingduration += (duration % 60) + 'm';
      }
    }
    let rowcss = "ms-Grid-row miparow";
    let editurl =
      "https://outlook.office.com/calendar/item/" +
      encodeURIComponent(this.props.data.id);
    // let editurl=this.props.data.webLink;
    let addressurl=`#`;
    let locatoinicon='ms-Icon ms-Icon--POI detailbodyicon';
    
    if(!!this.props.data.location.address){
      
      locatoinicon='ms-Icon ms-Icon--MapDirections detailbodyicon';
      let fulladdress=this.props.data.location.displayName;
      if(!!this.props.data.location.address.street){
        fulladdress +=', '+this.props.data.location.address.street;
      }
      if(!!this.props.data.location.address.city){
        fulladdress +=', '+this.props.data.location.address.city;
      }
      if(!!this.props.data.location.address.postalCode){
        fulladdress +=' '+this.props.data.location.address.postalCode;
      }
      if(!!this.props.data.location.address.state){
        fulladdress +=' '+this.props.data.location.address.state;
      }
      if(!!this.props.data.location.address.countryOrRegion){
        fulladdress +=' '+this.props.data.location.address.countryOrRegion;
      }
      if(!!fulladdress){
        addressurl=`https://www.google.com/maps/dir//${fulladdress}`;
      } else{
        locatoinicon='';
      }
      
    } else if(this.props.data.onlineMeeting){
      addressurl=this.props.data.onlineMeeting.joinUrl;
    }
    return (
      <div className="webpart">
        <div className="webpartTitle">
          <i className="ms-Icon ms-Icon--Calendar" />
          {this.props.phrases.title}
          <a
            className="openlink"
            title={this.props.phrases.edit}
            href={editurl}
            target="_blank"
          >
            <i className="ms-Icon ms-Icon--EditSolid12" />
          </a>
        </div>
        <div className="webpartbody">
          <div className="ms-Grid">
            <div className={rowcss}>
              <div className="ms-Grid-col ms-sm12">
              
                <EventDetail
                  data={this.props.data}
                  phrases={this.props.phrases}
                />
                <Facepile {...this.getorganizer()} />
                <div className="startdateinfo">{DateHelper.GetDisplayDatestring(start,true)}({meetingduration})</div>
              </div>
            </div>
            {/* <div className={rowcss}>
              <div className="ms-Grid-col ms-sm12">
                <div>
                  <label className="label">{this.props.phrases.start} : </label>
                  <b>{DateHelper.GetDisplayDatestring(start,true)}({meetingduration})</b>
                </div>
              </div>
            </div>
            <div className={rowcss}>
              <div className="ms-Grid-col ms-sm12">
                <div>
                  <label className="label">{this.props.phrases.end} : </label>{" "}
                  {DateHelper.GetDisplayDatestring(end,true)}
                </div>
              </div>
            </div> 
            <div className={rowcss}>
              <div className="ms-Grid-col ms-sm12">
                <div
                  className="ellips"
                  title={this.props.data.organizer.emailAddress.name}
                >
                  <label className="label">
                    {this.props.phrases.organizer} :{" "}
                  </label>{" "}
                  {this.props.data.organizer.emailAddress.name}
                </div>
              </div>
            </div>*/}
            <div className={rowcss}>
              <div className="ms-Grid-col ms-sm12">
                {addressurl=='#'?(
                   <div
                      className="ellips"
                      title={this.props.data.location.displayName}>
                      <label className="label">
                      {this.props.phrases.location} :{" "}
                        </label>{" "}
                      {this.props.data.location.displayName}
                   </div>
                ):(
                  <div
                    style={{marginLeft:'8px'}}
                    className="ellips"
                    title={this.props.data.location.displayName}>
                    <i style={{marginRight:'20px'}} className={locatoinicon} />
                    <a style={{textDecoration:'none'}} href={addressurl} target='_blank'>{this.props.data.location.displayName}</a> 
                  </div>
                )}
              </div>
            </div>
           {this.props.data.hasAttachments?(
             <EventAttachmentlist data={this.props.data} phrases={this.props.phrases} GetEventAttachment={this.props.GetOutlookemailAttachments} />
           ):null}
            {
              this.props.data.attendees && this.props.data.attendees.length>0?(
                <div>
                  <div className={rowcss}>
                    <div className="ms-Grid-col ms-sm12">
                          <div className="summaryitem">
                              <span className="value">{Math.floor((100*this.attendeeattending.length)/this.props.data.attendees.length)}%</span>
                              <span className="caption">{this.props.phrases.outlookeventattending}</span>
                          </div>
                          <div className="summaryitem">
                              <span className="value">{this.props.data.attendees.length}</span>
                              <span className="caption">{this.props.phrases.outlookeventinvited}</span>
                          </div>
                    </div>
                    
                  </div>
                  <div className={rowcss}>
                    <div className="ms-Grid-col ms-sm12">
                      <EventAttendeelist 
                        attendeeattending={this.attendeeattending}
                        attendeedeclaine={this.attendeedeclaine}
                        attendeenotresponse={this.attendeenotresponse}
                        attendeetentative={this.attendeetentative} 
                        data={this.props.data}
                        phrases={this.props.phrases}
                        Getcrmdataforrecent={this.props.Getcrmdataforrecent}
                        PrepareContactCRMReportUI={this.props.PrepareContactCRMReportUI}
                        PrepareContactCRMSSOUI={this.props.PrepareContactCRMSSOUI}
                        GetCRMContactCompany={this.props.GetCRMContactCompany}
                        GetContactRelatedMails={this.props.GetContactRelatedMails}
                      />
                    </div>
                  </div>
                </div>
              ):null
            }
            <div className={rowcss}>
              <div className="ms-Grid-col ms-sm12">
                {this.props.data.responseStatus.response==="accepted"?(
                  <div className="acceptedblock">
                  <i className="ms-Icon ms-Icon--CompletedSolid" />
                  <span>{this.props.phrases.outlookaccepted}</span>
              </div>
                ):this.props.data.responseStatus.response==="notResponded" && this.props.data.col>=0?(
                  <div className="acceptblock">
                    <span className="title">{this.props.phrases.outlookeventresponse}</span>
                    <div className="actionblock">
                        <span  onClick={()=> {this.AcceptEvent("accept");}} className="action">{this.props.phrases.outlookeventresponseyes}</span>
                        <span  onClick={()=> {this.AcceptEvent("decline");}} className="action">{this.props.phrases.outlookeventresponseno}</span>
                    </div>
                </div>
                ):null}
              </div>
            </div>
            {this.props.data.col>=0 && (
              <div className={rowcss}>
              <div className="ms-Grid-col ms-sm12">
                <div className="bookheading">{this.props.phrases.bookpreperationheading}</div>
                <div className="outlookeventbookcontainer">
                    <div  className={fifteenmincss} onClick={()=> {this.PerformPreperationEvent(fifteenmincss,-15);}}>
                        <span className="normaltext">{fifteenmincaption}</span>
                        <span className="overtext">{fifteenminovercaption}</span>

                    </div>
                    <div  className={thirtymincss} onClick={()=> {this.PerformPreperationEvent(thirtymincss,-30);}}>
                        <span className="normaltext">{thirtymincaption}</span>
                        <span className="overtext">{thirtyminovercaption}</span>

                    </div>
                </div>
              </div>
            </div>
            )}
             
            <div className={rowcss}>
              <div className="ms-Grid-col ms-sm12">
                <div className="assignecontainer">
                  <Facepile {...this.facepileProps} />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
  public AcceptEvent=(endpint)=>{
    endpint=`/${this.props.data.id}/${endpint}`;
    this.props.AcceptEvent(endpint,this.props.data.col);
  }
  public PerformPreperationEvent=(activestatus,type)=>{
    let childid=this.props.data.prepid;
    let prepevt=null;
    if(activestatus.indexOf('outlookeventbookbuttondisable')>=0){
      return;
    } else if(activestatus.indexOf('outlookeventbookbuttonactive')>=0){
      // it will delete event
    } else{
      //TODO Need to change
       //let newstarttime= moment(this.props.data.start.dateTime).add(type, 'm').format("YYYY-MM-DDTHH:mm:ss.SSSS");
       let newstarttime= moment(this.props.data.start.dateTime).add(type, 'm').format("YYYY-MM-DDTHH:mm:ss.SSSS");
       /*let options:Intl.DateTimeFormatOptions = {
        year: 'numeric', month: 'numeric', day: 'numeric',
        hour: 'numeric', minute: 'numeric',
        hour12: true
    };*/
    /* let date=new Date();
    if (this.props.data.start.dateTime instanceof Date) {  // d.valueOf() could also work
      date=this.props.data.start.dateTime;
    } else {
      date=new Date(this.props.data.start.dateTime);
    }
    debugger
       let newstarttime=new Intl.DateTimeFormat("YYYY-MM-DDTHH:mm:ss.SSSS", options).
       format(date);
       console.log(newstarttime); */
       

       //let orginalstarttime=this.props.data.start.dateTime.split('T');
       //let timeparts=orginalstarttime[1].split(':');
      //  timeparts[1]=parseInt(timeparts[1],0)+type;
      //  if(timeparts[1]<0){
      //    timeparts[1]=60+timeparts[1];
      //    timeparts[0]=parseInt(timeparts[0],0)-1;
      //  }
      //orginalstarttime[0]+'T'+timeparts[0]+':'+ timeparts[1]+':00.0000000',
       prepevt = {
        subject: this.props.phrases.bookeventsubject.replace('{0}', this.props.data.subject),
        "start": {
            "dateTime": newstarttime,
            "timeZone": this.props.data.start.timeZone
        },
        "end": this.props.data.start,
        "singleValueExtendedProperties": [
            {
                "id": this.props.extpropid,
                "value": "0####parentid####" + this.props.data.id
            }
        ]
    };
    }
    this.props.CreateOrCancelPreperationEvent(this.props.data.id,childid,prepevt,this.props.data.col,type);
  }
}
{/* <p dangerouslySetInnerHTML={{__html: post.content}}></p> */}